import { t } from "i18next";
import OutputData from "../../../components/ui/output_data/OutputData";
import styles from "./styles/SummaryOutput.module.css";

/**
 * Summary output component
 * Output for one entry
 */
const SummaryOutput = ({
    outputLabel, // {String} - The label for the output
    value, // {String|Number} - The value to be displayed
    number,
}) => {
    return (
        <div
            className={`${styles.main_summary_output_container} flex-container`}
        >
            <div
                className={`${styles.summary_output_container}  flex-container`}
            >
                <h3 className={`${styles.summary_output_label} flex-container`}>
                    <span className={`${styles.text}`}>{t(outputLabel)}</span>{" "}
                    <span className={`${styles.colon}`}>:</span>
                </h3>
                <div
                    className={`${styles.summary_output_value_container} ${
                        number ? styles.outputNumber : ""
                    } flex-container`}
                >
                    <OutputData data={value} align={"center"} />
                </div>
            </div>
        </div>
    );
};

export default SummaryOutput;
